import { Chip } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  title: ReactNode;
};

export const TripTag = ({ title }: Props) => {
  return (
    <Chip
      label={title}
      sx={{
        ".MuiChip-label": {
          paddingX: "calc(var(--spacing)*2)",
          paddingY: "calc(var(--spacing)*1)",
          fontWeight: "var(--font-weight-medium)",
          color: "var(--color-text-title)",
          fontSize: "var(--text-sm)",
        },
        height: "auto",
        backgroundColor: "var(--color-surface-accent-softer)",
      }}
    />
  );
};
